module.exports = __webpack_public_path__ + "img/GQ.b5628c49.png";